import cx from 'classnames'

import MenuItem, { type ItemType } from './menu-item'

interface MenuProps {
  id?: string
  items: ItemType[]
  hasFocus?: boolean
  useMegaNav?: boolean
  onClick?: () => void
  className?: string
  isFooterMenu?: boolean
  isHeaderDesktopMenu?: boolean
  isHeaderMobilePrimaryMenu?: boolean
  isHeaderMobileSecondaryMenu?: boolean
  isMegaNavMenu?: boolean
}

const Menu = ({
  id,
  items,
  hasFocus = true,
  useMegaNav = false,
  onClick,
  isFooterMenu,
  isHeaderDesktopMenu,
  isHeaderMobilePrimaryMenu,
  isHeaderMobileSecondaryMenu,
  isMegaNavMenu,
  className,
}: MenuProps) => {
  return (
    <ul
      className={cx(
        {
          'flex flex-col gap-y-1': isFooterMenu,
          'flex flex-wrap gap-x-6': isHeaderDesktopMenu,
          'flex flex-col gap-y-5': isHeaderMobilePrimaryMenu,
          'flex flex-col gap-y-2': isHeaderMobileSecondaryMenu || isMegaNavMenu,
        },
        className,
      )}
    >
      {items.map((item) => {
        return (
          <li
            key={item._key}
            className={cx({
              'inline-flex flex-col justify-center align-center':
                isHeaderDesktopMenu,
              'leading-5': isFooterMenu,
            })}
          >
            <MenuItem
              menuId={id}
              item={item}
              hasFocus={hasFocus}
              onClick={onClick}
              useMegaNav={useMegaNav}
              isFooterMenuItem={isFooterMenu}
              isHeaderDesktopMenuItem={isHeaderDesktopMenu}
              isHeaderMobilePrimaryMenuItem={isHeaderMobilePrimaryMenu}
              isHeaderMobileSecondaryMenuItem={isHeaderMobileSecondaryMenu}
              isMegaNavMenuItem={isMegaNavMenu}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default Menu
